import { createGlobalStyle } from 'styled-components'
import styledNormalize from 'styled-normalize'

import { fonts } from './fonts'
import { scaffolding } from './scaffolding'
import { getTheme, helpers } from './theme'
import { types } from './types'

export type { Theme } from './theme'

export { getTheme, helpers }

export const GlobalStyle = createGlobalStyle`
	${fonts}
	${styledNormalize}
	${scaffolding}
	${types}
`
